export default __webpack_public_path__ + "static/media/holland.c2813ab0.jpg";